import React from 'react'
import '../shop_now/ShopNow.css'
import { Col, Container, Row } from 'react-bootstrap'
const ShopNow = () => {
  return (
    <>
    <section id="shop_now">
      <Container>
        <Row style={{rowGap:'20px'}}>
          <Col lg={4}>
            <div class="shop_manu">
              <div class="shop_manu_inner">
                <p>20% off</p>
                <h4>Everyday Fresh With Organic</h4>
                <a href=""> shop now</a>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div class="shop_manu_a">
              <div class="shop_manu_inner">
                <p>20% off</p>
                <h4>Everyday Fresh With Organic</h4>
                <a href=""> shop now</a>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div class="shop_manu_b">
              <div class="shop_manu_inner">
                <p>20% off</p>
                <h4>Everyday Fresh With Organic</h4>
                <a href=""> shop now</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  )
}

export default ShopNow